var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCovidHospitals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#covid-hospitals_svg__clip0)",
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M31.426 0H1.574C.98 0 .5.48.5 1.074v29.852C.5 31.52.98 32 1.574 32h29.852c.593 0 1.074-.48 1.074-1.074V1.074C32.5.48 32.02 0 31.426 0zm-1.074 29.852H2.648V2.148h27.704v27.704z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.72 25.854h5.268c.593 0 1.074-.481 1.074-1.074v-5.072h4.876v5.072c0 .593.481 1.074 1.074 1.074h5.268c.593 0 1.074-.481 1.074-1.074V7.22c0-.593-.481-1.074-1.074-1.074h-5.268c-.593 0-1.074.48-1.074 1.074v5.072h-4.876V7.22c0-.593-.481-1.074-1.074-1.074H7.72c-.593 0-1.074.48-1.074 1.074v17.56c0 .593.48 1.074 1.074 1.074zm1.074-17.56h3.12v5.072c0 .593.48 1.074 1.074 1.074h7.024a1.074 1.074 0 001.074-1.074V8.294h3.12v15.412h-3.12v-5.072c0-.593-.481-1.074-1.074-1.074h-7.024a1.074 1.074 0 00-1.074 1.074v5.072h-3.12V8.294z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "covid-hospitals_svg__clip0"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(.5)",
    d: "M0 0h32v32H0z"
  })))));
}

export default SvgCovidHospitals;